import { useContext, useEffect, useState } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { abpnClient } from "../../../Services/AbpnClient";
import { AuthContext } from "../../Auth/AuthProvider";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import Message, { MessageAttachment } from "../Models/Message";

export default function Messages() {

    const [messages, setMessages] = useState<Array<Message>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const authContext = useContext(AuthContext);

    useEffect(() => {
        const loadMessages = async () => {
            setIsLoading(true);
            const results = await abpnClient.get<Array<Message>>('/api/physician/GetMessages', authContext);
            setMessages(results);
            setIsLoading(false);
        }

        if (!isLoading) {
            loadMessages();
        }
    }, [authContext]);

    const downloadMessageDocument = async (message: Message) => {
        var response = await abpnClient.getResponse(`/api/physician/DownloadMessageDocument?messageId=${message.messageId}`, authContext)
        var blob = await response.blob();

        const downloadFileUrl = window.URL.createObjectURL(
            new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = downloadFileUrl;
        link.setAttribute(
            'download',
            `${message.messageTemplateName ? message.messageTemplateName : message.subject} Message Document.pdf`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    const downloadMessageAttachment = async (messageAttachment: MessageAttachment) => {
        var response = await abpnClient.getResponse(`/api/physician/DownloadMessageAttachment?messageAttachmentId=${messageAttachment.messageAttachmentId}`, authContext)
        var blob = await response.blob();

        const downloadFileUrl = window.URL.createObjectURL(
            new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = downloadFileUrl;
        link.setAttribute(
            'download',
            `${messageAttachment.documentName}`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    if (isLoading) return <AbpnSpinner></AbpnSpinner>
    if (messages.length === 0) return <div>There are no messages.</div>

    return (
        <Card className="mb-3" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="font-weight-bolder">
                    <span className="text-pp-primary">Messages</span>
                </Card.Title>
                <Row>
                    {messages.length === 0 ?
                        <div>There are no messages.</div>
                        :
                        <Col xs={12} md={12}>
                            <Table variant="sm" className="pp-fee-table pp-font-size-smaller">
                                <thead>
                                    <tr>
                                        <th className="mb-1 pp-table-header">Date</th>
                                        <th className="mb-1 pp-table-header">Message Type</th>
                                        <th className="mb-1 pp-table-header">Attachments</th>
                                        <th className="mb-1 pp-table-header">&nbsp;</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messages.map((_, index) =>
                                        <tr key={index}>
                                            <td>
                                                {getDateWithOffset(_.statusDate).toLocaleDateString()}
                                            </td>
                                            <td>
                                                {_.messageTemplateName}
                                            </td>
                                            <td>
                                                {_.attachments?.map(_ => {
                                                    return <button className={`btn btn-sm btn-clean btn-icon btn-icon-md px-0`} onClick={() => downloadMessageAttachment(_)}>
                                                                <a className="font-weight-bolder mb-1 pp-font-size-smaller">{_.documentName}</a>
                                                            </button>
                                                })}
                                            </td>
                                            <td>
                                                <button type="button" title="Download" className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                    onClick={() => downloadMessageDocument(_)}>
                                                    <a className="font-weight-bolder mb-1 pp-font-size-smaller">Download</a>
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    }
                </Row>
            </Card.Body>
        </Card>
    );
}